// Migrated from app/assets/javascripts/order.js
// AngularJS order controller - kept as-is (1-op-1 copy)
// This file defines the myApp Angular module with OrderCtrl

/*global angular */

(function() {
  'use strict';

  // Consent-check helper: lees window.AvayoConsent (gezet door _consent_bootstrap.html.erb)
  function consentOk(category) {
    return !!(window.AvayoConsent && window.AvayoConsent[category]);
  }

  // GA4 Ecommerce helper functions
  function trackGA4Event(eventName, params) {
    if (!consentOk('analytics')) return;
    if (typeof gtag === 'function') {
      gtag('event', eventName, params);
    }
  }

  function buildGA4Item(product, eventId, quantity) {
    var price = parseFloat(product.price) || 0;
    return {
      item_id: String(product.id),
      item_name: product.name_nl,
      item_category: String(eventId),
      price: parseFloat(price.toFixed(2)),
      quantity: quantity
    };
  }

  function buildGA4Items(products, eventId) {
    var items = [];
    angular.forEach(products, function(product) {
      if (product.amount && product.amount > 0) {
        items.push(buildGA4Item(product, eventId, product.amount));
      }
    });
    return items;
  }

  // TikTok Pixel helpers (parallel aan GA4) — geen-op als pixel niet geladen is OF marketing-consent niet gegeven
  function trackTikTokEvent(eventName, params) {
    if (!consentOk('marketing')) return;
    if (typeof ttq !== 'undefined' && ttq && typeof ttq.track === 'function') {
      ttq.track(eventName, params);
    }
  }

  function buildTikTokContent(product, quantity) {
    var price = parseFloat(product.price) || 0;
    return {
      content_id: String(product.id),
      content_type: 'product',
      content_name: product.name_nl,
      quantity: quantity,
      price: parseFloat(price.toFixed(2))
    };
  }

  function buildTikTokContents(products) {
    var contents = [];
    angular.forEach(products, function(product) {
      if (product.amount && product.amount > 0) {
        contents.push(buildTikTokContent(product, product.amount));
      }
    });
    return contents;
  }

  // Meta Pixel helpers (parallel aan GA4/TikTok) — no-op als pixel niet geladen is OF marketing-consent niet gegeven
  function trackMetaEvent(eventName, params) {
    if (!consentOk('marketing')) return;
    if (typeof fbq === 'function') {
      fbq('track', eventName, params);
    }
  }

  // Bouwt {contents, content_ids} voor Meta-events op basis van product-array.
  // Bij quantityOverride wordt voor elk product die quantity gebruikt (bv. 1 voor ViewContent);
  // anders product.amount.
  function buildMetaPayload(products, quantityOverride) {
    var contents = [];
    var ids = [];
    angular.forEach(products, function(product) {
      var qty = quantityOverride !== undefined ? quantityOverride : product.amount;
      if (qty && qty > 0) {
        contents.push({ id: String(product.id), quantity: qty });
        ids.push(String(product.id));
      }
    });
    return { contents: contents, content_ids: ids };
  }

  var DUTCH_COUNTRY_ID = '172';
  var myApp = angular.module("myApp", ["myApp.directives", "ngResource", "ui.bootstrap", "checklist-model"]);


  myApp.filter("range", function() {
    return function(input, min, max, free) {
      min = parseInt(min); //Make string input int
      max = parseInt(max);
      if (free !== undefined) {
        free = parseInt(free);
        if (free < max) {
          max = free;
        }
      }
      var i;
      for (i = min; i <= max; i += 1) {
        input.push(i);
      }
      return input;
    };
  });

  myApp.filter("removeEmptyOrderItems", function() {
    return function(items) {
      var filtered = [];
      angular.forEach(items, function(item) {
        if (item.amount > 0) {
          filtered.push(item);
        }
      });
      return filtered;
    };
  });

  myApp.factory("EventFactory", ["$resource", function($resource) {
    // send the locale for filtering product variant's active flag (locale)
    return $resource("/api/events/:id?locale=" + I18n.locale);
  }]);

  myApp.factory("OrderFactory", ["$resource", function($resource) {
    return $resource("/api/orders/:id");
  }]);

  myApp.controller("OrderCtrl", ["$scope", "$http", "$location", "$filter", "EventFactory", "OrderFactory", "$sce", "$timeout", function($scope, $http, $location, $filter, EventFactory, OrderFactory, $sce, $timeout) {
    $scope.ideal = false;
    $scope.autoZipcodeLookup = true;
    $scope.submitted = false;
    $scope.formValidAndSubmitted = false;
    $scope.buttonDisabled = false;
    $scope.order_id = null;
    $scope.performance = null;
    $scope.discount = 0;
    $scope.orderTotal = 0;
    $scope.handlingCost = 0;
    $scope.number_of_free_tickets = 0;
    $scope.promo_message = "";
    $scope.promo_class = "";
    $scope.promo_code = "";
    $scope.errorMessage = "";
    $scope.order_items = [];
    $scope.promo_codes = [];
    $scope.performance_dates = [];
    $scope.formData = {
      order: {
        locale: I18n.locale, customer_attributes: {}
      }
    };

    // set default country
    $scope.country = 1;
    $scope.formData.order.customer_attributes.country_id = DUTCH_COUNTRY_ID;
    // init memo fields
    var div1 = document.getElementById("memo1_values");
    if (div1) {
      $scope.memo1_values = div1.getAttribute("data-memo").split(";");
    }
    var div2 = document.getElementById("memo2_values");
    if (div2) {
      $scope.memo2_values = div2.getAttribute("data-memo").split(";");
    }
    var div3 = document.getElementById("memo3_values");
    if (div3) {
      $scope.memo3_values = div3.getAttribute("data-memo").split(";");
    }

    // Reset button state on terugkeer naar deze page — zowel bfcache (browser back)
    // als redirect na geannuleerde betaling. Zonder deze reset bleef #btn-pay
    // disabled na annulering bij PayNL.
    window.addEventListener('pageshow', function(event) {
      $scope.$apply(function() {
        $scope.buttonDisabled = false;
        $scope.formValidAndSubmitted = false;
        $scope.submitted = false;
      });
    });

    // Date picker
    angular.forEach($("#date_picker_data").data("performance-dates"), function(date) {
      $scope.performance_dates.push(date);
    });

    function getDateDisabled(data) {
      var date = data.date,
          mode = data.mode;
      return (mode === "day" && ($scope.performance_dates.indexOf($filter("date")(date, "MM/dd/yyyy")) == -1));
    }

    function getDayClass(data) {
      return '';
    }

    function recomputeAllProductMaxChoices($scope) {
      if (!$scope || !$scope.performance || !$scope.event_data) return;

      const toInt = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? Math.max(0, Math.floor(n)) : 0;
      };
      const perfSeatsCap0 = Math.max(0, toInt($scope.performance.free_capacity));

      const allPerfProducts = [];
      angular.forEach($scope.event_data.categories, (cat) => {
        angular.forEach(cat.products, (p) => {
          if (p && p.performance_stock_enabled) allPerfProducts.push(p);
        });
      });

      const orderItemsById = {};
      if (Array.isArray($scope.order_items)) {
        for (const oi of $scope.order_items) orderItemsById[oi.id] = toInt(oi.amount);
      }
      const getCurrentAmount = (p) => {
        if (p != null && p.amount != null) return toInt(p.amount);
        return toInt(orderItemsById[p.id]);
      };
      const tpuOf = (p) => Math.max(1, toInt(p.nr_physical_tickets || 1));

      const productUnitsCapById = {};
      for (const p of allPerfProducts) {
        const capUnits = Math.max(0, toInt(getAvailableStock(p, $scope.performance)));
        productUnitsCapById[p.id] = capUnits;
      }

      const lastId = Number($scope._lastUpdatedProductId);
      const ordered = [];
      if (lastId && allPerfProducts.some(p => Number(p.id) === lastId)) {
        const last = allPerfProducts.find(p => Number(p.id) === lastId);
        ordered.push(last);
        for (const p of allPerfProducts) if (Number(p.id) !== lastId) ordered.push(p);
      } else {
        Array.prototype.push.apply(ordered, allPerfProducts);
      }

      let remainingPerfSeats = perfSeatsCap0;
      let anyClamped = false;

      for (const product of ordered) {
        const ticketsPerUnit = tpuOf(product);
        const productUnitsCap = productUnitsCapById[product.id] || 0;

        const allowedUnits = Math.max(
          0,
          Math.min(productUnitsCap, Math.floor(remainingPerfSeats / ticketsPerUnit))
        );

        product.sold_out = (productUnitsCap === 0)
          ? {"text-decoration": "line-through"}
          : null;

        product.free_capacity = allowedUnits;

        const current = getCurrentAmount(product);
        const clamped = Math.min(current, allowedUnits);

        if (clamped !== current) {
          anyClamped = true;
          product.amount = clamped;
          syncOrderItemAmount($scope, product.id, clamped);
        } else {
          if (product.amount !== current) product.amount = current;
          syncOrderItemAmount($scope, product.id, current);
        }

        remainingPerfSeats = Math.max(0, remainingPerfSeats - (clamped * ticketsPerUnit));
      }

      if (anyClamped && !$scope._stockClampWarned) {
        $scope._stockClampWarned = true;
        bootbox.alert(
          "Het door u gekozen aantal tickets zijn voor de gekozen datum niet meer voorradig. <br><br>" +
          "<strong>Let op:</strong> Het systeem heeft het aantal tickets aangepast naar het, op dit moment, maximaal beschikbare aantal."
        );
      }

      function syncOrderItemAmount($scope, productId, amount) {
        if (!Array.isArray($scope.order_items)) $scope.order_items = [];
        const idx = $scope.order_items.findIndex(oi => Number(oi.id) === Number(productId));
        if (amount > 0) {
          if (idx >= 0) $scope.order_items[idx].amount = toInt(amount);
          else $scope.order_items.push({ id: productId, amount: toInt(amount) });
        } else if (idx >= 0) {
          $scope.order_items.splice(idx, 1);
        }
      }
    }

    function getAvailableStock(product, performance) {
      if (!product || !performance) return 0;

      const toInt = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? Math.max(0, Math.floor(n)) : 0;
      };

      const ticketsPerUnit = Math.max(1, toInt(product.nr_physical_tickets || 1));
      const perfCap = toInt(performance.free_capacity);

      let bottleneckCap = perfCap;

      if (toInt(product.stock_enabled) > 0) {
        const matches = Array.isArray(product.stock_records)
          ? product.stock_records.filter(r => r && r.performance_id == performance.id)
          : [];

        if (matches.length > 0) {
          const recordCaps = matches.map(r => toInt(r.free_capacity));
          bottleneckCap = Math.min(perfCap, ...recordCaps);
        }
      }

      return Math.max(0, Math.floor(bottleneckCap / ticketsPerUnit));
    }

    $scope.options = {
      customClass: getDayClass,
      showWeeks: false,
      startingDay: 1,
      initDate: new Date($("#date_picker_data").data("init-date")),
      dateDisabled: getDateDisabled
    };

    $scope.setIdeal = function(show) {
      $scope.ideal = show;
    };

    $scope.coupleZipcode = function() {
      if ($scope.country == DUTCH_COUNTRY_ID) {
        $scope.formData.order.customer_attributes.zipcode = $scope.zipcode_nl;
      } else {
        $scope.formData.order.customer_attributes.zipcode = $scope.zipcode;
      }
    };

    $scope.dstOffset = function(strPerformanceDate) {
      if (strPerformanceDate !== undefined) {
        return strPerformanceDate.substring(23);
      }
      return '';
    };

    $scope.$watch("zipcode_nl", $scope.coupleZipcode);
    $scope.$watch("zipcode", $scope.coupleZipcode);

    $scope.setCountry = function(country_id) {
      $scope.formData.order.customer_attributes.street = "";
      $scope.formData.order.customer_attributes.housenumber = "";
      $scope.formData.order.customer_attributes.zipcode = "";
      $scope.formData.order.customer_attributes.city = "";
      $scope.formData.order.customer_attributes.country_id = country_id;
    };

    $scope.mandatoryProductRange = function(product) {
      var range = $filter('range')([], product.min_range, product.max_range, product.free_capacity);
      angular.forEach($scope.products, function(_product) {
        if ((_product.id === product.id) && (_product.amount === 0)) {
          _product.amount = range[0];
          $scope.update({product_id: product.id, product_amount: range[0]});
        }
      });
      return range;
    };

    $scope.relationNumberValidation = function() {
      $scope.relationNumberValid = false;
      if ((angular.isUndefined($scope.relationNumber)) || ($scope.relationNumber.length < 3)) {
        $scope.form.relation_number.$setValidity("numbernotcomplete", false);
        $scope.relationNumberClass = "has-error has-feedback";
        $scope.relationNumberGlyphiconClass = "glyphicon-remove";
        return;
      }

      $scope.relationNumberClass = "has-warning has-feedback";
      $scope.relationNumberGlyphiconClass = "glyphicon-repeat gly-spin";

      var ajax_params = {};
      ajax_params.method = "POST";
      ajax_params.url = "/transactions/validate_relation_number";
      ajax_params.data = $.param({
        transaction: {
          event_id: $scope.formData.order.event_id,
          relation_number: $scope.relationNumber,
          order_id: $scope.order_id
        }
      });
      ajax_params.headers = {"Content-Type": "application/x-www-form-urlencoded"};

      var responsePromise = $http(ajax_params);
      responsePromise.success(function(data, status, headers, config) {
        $scope.form.relation_number.$setValidity("numbernotcomplete", true);
        $scope.form.relation_number.$setValidity("numbernotfound", true);
        $scope.form.relation_number.$setValidity("numberalreadyused", true);
        if (data.result == "success") {
          $scope.relationNumberClass = "has-success has-feedback";
          $scope.relationNumberGlyphiconClass = "glyphicon-ok";
          $scope.relationNumberValid = true;
        } else {
          $scope.form.relation_number.$setValidity(data.error_key, false);
          $scope.relationNumberClass = "has-error has-feedback";
          $scope.relationNumberGlyphiconClass = "glyphicon-remove";
          $scope.relationNumberValid = false;
        }
      });
      // AT-1434: niet blijven draaien als de controle zelf faalt
      responsePromise.error(function() {
        $scope.relationNumberClass = "has-error has-feedback";
        $scope.relationNumberGlyphiconClass = "glyphicon-remove";
        bootbox.alert(I18n.t("js.technical_problems"));
      });
    };

    $scope.zipcodeLookupLoading = false;
    var zipcodeLookupTimer = null;

    // Debounced trigger: aangeroepen vanuit ng-change op postcode + huisnummer.
    // Wacht tot de gebruiker even niet meer typt voordat we een lookup doen.
    $scope.scheduleZipcodeLookup = function() {
      if (zipcodeLookupTimer) {
        $timeout.cancel(zipcodeLookupTimer);
      }
      $scope.zipcodeLookupSuccess = false;

      var zipcode = ($scope.zipcode_nl || "").trim();
      var customerAttrs = $scope.formData && $scope.formData.order && $scope.formData.order.customer_attributes;
      var housenumber = customerAttrs ? customerAttrs.housenumber : null;

      var hasValidZip = /^\d{4} ?[A-Za-z]{2}$/.test(zipcode);
      var hasHousenumber = housenumber != null && /\d/.test(housenumber.toString());

      if (!hasValidZip || !hasHousenumber) {
        $scope.zipcodeLookupLoading = false;
        return;
      }

      $scope.zipcodeLookupLoading = true;
      zipcodeLookupTimer = $timeout(function() {
        $scope.zipcodeDutchLookup();
      }, 400);
    };

    $scope.zipcodeDutchLookup = function() {
      var zipcode = $scope.zipcode_nl;
      var housenumber = $scope.formData.order.customer_attributes.housenumber;
      if ((!angular.isUndefined(zipcode)) && (!angular.isUndefined(housenumber))) {
        zipcode = escape(zipcode.replace(" ", ""));
        var strippedNumber = housenumber.match(/^\d+|\d+\b|\d+(?=\w)/g);
        if (strippedNumber === null) {
          strippedNumber = 'xxx';
        } else {
          strippedNumber = strippedNumber[0];
        }
        $scope.zipcodeLookupLoading = true;
        $http({
          method: "GET",
          url: "/services/dutch_zipcode_lookup/" + zipcode + "/" + strippedNumber
        }).then(function successCallback(response) {
          $scope.zipcodeLookupLoading = false;
          if (response.data.street.length > 0) {
            $scope.autoZipcodeLookup = true;
            $scope.zipcodeLookupSuccess = true;
            $scope.formData.order.customer_attributes.zipcode = response.data.zipcode;
            $scope.formData.order.customer_attributes.street = response.data.street;
            $scope.formData.order.customer_attributes.city = response.data.city;
            $("#zipcode_nl").tooltip("hide");
          } else {
            $scope.autoZipcodeLookup = false;
            $scope.zipcodeLookupSuccess = false;
            $scope.formData.order.customer_attributes.street = '';
            $scope.formData.order.customer_attributes.city = '';
            $("#zipcode_nl").tooltip("show");
            setTimeout(function() {
              $("#zipcode_nl").tooltip("hide");
            }, 6000);
          }
        }, function errorCallback(response) {
          $scope.zipcodeLookupLoading = false;
          $scope.zipcodeLookupSuccess = false;
          $scope.autoZipcodeLookup = false;
          $("#zipcode_nl").tooltip("show");
          setTimeout(function() {
            $("#zipcode_nl").tooltip("hide");
          }, 6000);
        });
      }
    };

    $scope.init = function(event_id, order_id, available_payment_methods, promo_uuid, user_id, organisation) {
      var deferred_order;
      $scope.fees = [];
      $scope.fee_definitions = [];
      $scope.fees_total = 0;
      $scope.order_id = order_id;
      $scope.promo_uuid = promo_uuid;
      $scope.formData.order.event_id = event_id;
      $scope.formData.order.user_id = user_id;
      $scope.formData.order.customer_attributes.organisation = organisation;
      $scope.formData.order.payment_method = available_payment_methods[0];
      var params = {};
      params.id = event_id;
      if (!!promo_uuid) {
        params.uuid = promo_uuid;
      }
      if (!!$location.search().filter) {
        params.filter = $location.search().filter;
      }
      $scope.event_data = EventFactory.get(params);
      $scope.event_data.$promise.then(function(event_data) {
        $scope.event_data = event_data;
        $scope.event_data.html_info_nl = $sce.trustAsHtml(event_data.html_info_nl);
        $scope.products = _.flatten(_.map($scope.event_data.categories, function(category) {
          return category.products;
        }));

        // GA4: view_item_list event
        (function() {
          var items = [];
          angular.forEach($scope.products, function(product) {
            items.push(buildGA4Item(product, event_id, 1));
          });
          if (items.length > 0) {
            trackGA4Event('view_item_list', {
              item_list_id: String(event_id),
              item_list_name: event_data.name_nl || event_data.name_en || String(event_id),
              items: items
            });

            var ttContents = [];
            angular.forEach($scope.products, function(product) {
              ttContents.push(buildTikTokContent(product, 1));
            });
            trackTikTokEvent('ViewContent', {
              contents: ttContents
            });

            var metaPayload = buildMetaPayload($scope.products, 1);
            trackMetaEvent('ViewContent', {
              content_type: 'product',
              content_ids: metaPayload.content_ids,
              contents: metaPayload.contents
            });
          }
        })();

        // fees
        $scope.fee_definitions = event_data.fee_definitions || [];

        // Process pending date change
        if (pendingDateChange) {
          $scope.changedDate();
        }

        // set free capacity for limited product stock
        if (event_data.performances.length === 0) {
          angular.forEach($scope.event_data.categories, function(category) {
            angular.forEach(category.products, function(product) {
              if (product.stock_enabled > 0) {
                const toInt = (v) => {
                  const n = Number(v);
                  return Number.isFinite(n) ? Math.max(0, Math.floor(n)) : 0;
                };
                const ticketsPerUnit = Math.max(1, toInt(product.nr_physical_tickets || 1));
                const rawCap = toInt((product.stock_records && product.stock_records[0] && product.stock_records[0].free_capacity) || 0);
                const available_stock = Math.floor(rawCap / ticketsPerUnit);
                if (product.max_range > available_stock) {
                  product.max_range = available_stock;
                }
                product.sold_out = (available_stock === 0) ? {"text-decoration": "line-through"} : null;
                product.free_capacity = available_stock;
              }
            });
          });
        }

        // direct open time select modal if there are mutiple slots on only one date.
        if (event_data.performances.length > 1) {
          var unique = $scope.performance_dates.filter(function(v, i, a) {
            return a.indexOf(v) === i;
          });
          if (unique.length == 1) {
            $scope.dt = event_data.performances[0].start;
            $scope.changedDate();
          }
        }

        // set default performance
        if (event_data.performances.length == 1) {
          $scope.formData.order.performance_id = event_data.performances[0].id;
          $scope.performance = event_data.performances[0];
          $scope.dt = event_data.performances[0].start;

          angular.forEach($scope.event_data.categories, function(category) {
            angular.forEach(category.products, function(product) {
              var performance = event_data.performances[0];
              var available_stock = getAvailableStock(product, performance);

              product.sold_out = (available_stock === 0) ? {"text-decoration": "line-through"} : null;

              if (Number(product.max_range) > available_stock) {
                product.free_capacity = available_stock;
              } else {
                product.free_capacity = undefined;
              }
            });
          });

          recomputeAllProductMaxChoices($scope);
        }

        if ($scope.order_id !== "") {
          deferred_order.$promise.then(function(order_data) {
            if (order_data.paid_order != "true") {
              $scope.formData.order.payment_method = order_data.payment_method;
              $scope.formData.order.customer_attributes = order_data.customer;

              $("#phone").intlTelInput("setNumber", order_data.customer.phone);

              $scope.formData.order.performance_id = order_data.performance_id;
              $scope.changedDate2();

              if ($scope.formData.order.customer_attributes.country_id) {
                if ($scope.formData.order.customer_attributes.country_id == DUTCH_COUNTRY_ID) {
                  $scope.country = 1;
                  $scope.zipcode_nl = $scope.formData.order.customer_attributes.zipcode;
                  if (($scope.zipcode_nl !== null) && ($scope.zipcode_nl.length > 5)) {
                    $scope.zipcodeDutchLookup();
                  }
                } else {
                  $scope.country = 0;
                  $scope.zipcode = $scope.formData.order.customer_attributes.zipcode;
                }
              }

              angular.forEach(order_data.order_items, function(order_item) {
                angular.forEach($scope.products, function(product) {
                  if (product.id == order_item.product_id) {
                    product.amount = order_item.amount;
                    product.free_capacity = product.free_capacity + product.amount;
                    if ($scope.performance !== null) {
                      $scope.performance.free_capacity += product.amount;
                    }
                  }
                });
                $scope.update({
                  product_id: order_item.product_id,
                  product_amount: order_item.amount,
                  order_item_id: order_item.id
                });
              });

              // Force revalidate alle form controls: intl-tel-input bypasst Angular,
              // emailCheck-directive luistert alleen op blur/keyup, ng-required="orderTotal > 0"
              // hangt af van async-berekende orderTotal. Zonder dit blijft de form
              // .ng-invalid na cancel-redirect en wordt #btn-pay onklikbaar.
              $timeout(function() {
                if ($scope.form) {
                  angular.forEach($scope.form, function(ctrl, name) {
                    if (name.charAt(0) !== '$' && ctrl && typeof ctrl.$validate === 'function') {
                      ctrl.$validate();
                    }
                  });
                }
                $('#email_confirm').trigger('blur');
                $('#phone').trigger('input').trigger('change');
                $scope.buttonDisabled = false;
              }, 100);
            } else {
              $scope.order_id = "";
            }
          });
        } else {
          if (["ideal", "10"].indexOf($scope.formData.order.payment_method) != -1) {
            $scope.setIdeal(true);
          }
        }
      });
      if ($scope.order_id !== "") {
        deferred_order = OrderFactory.get({id: order_id});
      }

    };

    $scope.update = function(data) {
      if (data.product_id === null) {
        return;
      }

      $scope._lastUpdatedProductId = data && data.product_id;

      (function syncProductAmountEarly() {
        if (!data) return;
        var pid = Number(data.product_id);
        var amt = Number(data.product_amount) || 0;

        angular.forEach($scope.event_data.categories, function(cat) {
          angular.forEach(cat.products, function(p) {
            if (p && Number(p.id) === pid) {
              p.amount = amt;
            }
          });
        });
      })();

      build_order_items(data);
      calculate_total_and_handling_cost();

      if (!!$scope.promo_codes.length) {

        build_order_items_on_form_data();

        var ajax_params = {};
        ajax_params.method = "POST";
        ajax_params.url = "/transactions/redeem_promo_code";
        ajax_params.data = {
          transaction: {
            order: $scope.formData.order,
            relation_number: $scope.relationNumber
          }
        };
        if ($scope.promo_codes.length > 0) {
          ajax_params.data.transaction.codes = $scope.promo_codes;
        }
        var responsePromise = $http(ajax_params);
        responsePromise.success(function(data, status, headers, config) {
          if (data.result.type == "notice") {
            $scope.promo_class = "";
            $scope.promo_message = "";
            $scope.discount = 0;
            $scope.number_of_free_tickets = data.free_tickets;
            angular.forEach(data.order.order_items, function(backend_order_item) {
              $scope.discount += parseFloat(backend_order_item.discount);
            });
            if (data.order.discount_item) {
              $scope.discount += parseFloat(data.order.discount_item.discount);
            }
            calculate_total_and_handling_cost();
          }
          if (data.result.type == "error") {
            $scope.promo_class = "alert-danger";
          }
        });
        // AT-1434: de korting is niet herberekend, dus het getoonde totaal kan afwijken
        responsePromise.error(function() {
          $scope.promo_class = "alert-danger";
          $scope.promo_message = I18n.t("js.technical_problems");
        });
      }
      $scope._stockClampWarned = false;
      recomputeAllProductMaxChoices($scope);
    };

    function dateCheck(from, to, check) {
      var fDate = new Date(from).setHours(0, 0, 0, 0);
      var lDate = new Date(to).setHours(0, 0, 0, 0);
      var cDate = new Date(check).setHours(0, 0, 0, 0);
      if ((cDate <= lDate) && (cDate >= fDate)) {
        return true;
      }
      return false;
    }

    function account_is(subdomain) {
      return (window.location.hostname.indexOf(subdomain) != -1);
    }

    var pendingDateChange = false;

    $scope.changedDate = function() {
      if (!$scope.event_data || !$scope.event_data.performances) {
        pendingDateChange = true;
        return;
      }

      var dateString = $filter('date')($scope.dt, 'yyyy-MM-dd');
      $scope.selected_date_performances = $filter('filter')($scope.event_data.performances, {start: dateString});

      if (!$scope.selected_date_performances || $scope.selected_date_performances.length === 0) {
        return;
      }

      if (($scope.selected_date_performances.length > 1) || account_is('smokeboat')) {
        $('#timePicker').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else {
        $scope.setPerformance($scope.selected_date_performances[0]);
      }

      pendingDateChange = false;
    };

    var hideDatepickerError = function() {
      if ($scope.datepickerSubmitted) {
        setTimeout(function() {
          $scope.datepickerFadingOut = true;
          $scope.$apply();

          setTimeout(function() {
            $scope.datepickerSubmitted = false;
            $scope.datepickerFadingOut = false;
            $scope.$apply();
          }, 500);
        }, 0);
      }
    };

    var hideProductsError = function() {
      if ($scope.productsSubmitted && $scope.nrTickets > 0) {
        setTimeout(function() {
          $scope.productsFadingOut = true;
          $scope.$apply();

          setTimeout(function() {
            $scope.productsSubmitted = false;
            $scope.productsFadingOut = false;
            $scope.$apply();
          }, 500);
        }, 0);
      }
    };

    $scope.changedDate2 = function() {
      angular.forEach($scope.event_data.performances, function(performance) {
        if (performance.id == $scope.formData.order.performance_id) {
          $scope.performance = performance;
          $scope.dt = performance.start;
          $scope.adjustCarouselAndStock();
          hideDatepickerError();
        }
      });
    };

    // Pay by Bank: disable/enable based on selected performance start time
    function updatePayByBankAvailability(performance) {
      var $card = $('[data-pay-by-bank]');
      if (!$card.length) return;

      var cutoffHours = parseInt($('[data-pay-by-bank-cutoff-hours]').data('pay-by-bank-cutoff-hours'), 10);
      if (isNaN(cutoffHours)) return;

      var perfStart = new Date(performance.start);
      var cutoffTime = new Date(Date.now() + cutoffHours * 3600 * 1000);
      var disabled = perfStart < cutoffTime;

      var $radio = $card.find('input[type="radio"]');
      $radio.prop('disabled', disabled);
      $card.toggleClass('disabled', disabled);
      $card.find('.pay-by-bank-notice').toggle(!disabled);
      $card.find('.pay-by-bank-disabled').toggle(disabled);

      // If Pay by Bank was selected and is now disabled, deselect it
      if (disabled && $radio.length && $scope.formData.order.payment_method == $radio.val()) {
        $scope.formData.order.payment_method = null;
      }
    }

    // AT-1228: overboeking uitschakelen zodra het evenement te dichtbij is. Een SEPA-
    // overboeking is 1-3 werkdagen onderweg, dus dan komt het geld niet meer op tijd.
    // Zelfde opzet als updatePayByBankAvailability hierboven.
    function updateBankTransferAvailability(performance) {
      var $card = $('[data-bank-transfer]');
      if (!$card.length) return;

      var minDays = parseInt($('[data-bank-transfer-min-days]').data('bank-transfer-min-days'), 10);
      if (isNaN(minDays)) return;

      var perfStart = new Date(performance.start);
      var cutoffTime = new Date(Date.now() + minDays * 24 * 3600 * 1000);
      var disabled = perfStart < cutoffTime;

      var $radio = $card.find('input[type="radio"]');
      $radio.prop('disabled', disabled);
      $card.toggleClass('disabled', disabled);
      $card.find('.bank-transfer-disabled').toggle(disabled);

      // Stond overboeking al aangevinkt, dan die keuze weghalen.
      if (disabled && $radio.length && $scope.formData.order.payment_method == $radio.val()) {
        $scope.formData.order.payment_method = null;
      }
    }

    $scope.setPerformance = function(performance) {
      $scope.performance = performance;
      $scope.formData.order.performance_id = performance.id;
      $scope.adjustCarouselAndStock();
      hideDatepickerError();
      updatePayByBankAvailability(performance);
      updateBankTransferAvailability(performance);

      trackGA4Event('select_item', {
        item_list_id: String($scope.formData.order.event_id),
        item_list_name: 'Time slots',
        items: [{
          item_id: String(performance.id),
          item_name: performance.start,
          item_category: 'performance'
        }]
      });

      var locale = document.documentElement.lang || 'nl';
      var infoText = performance['info_' + locale] || performance.info_nl;
      if (infoText) {
        bootbox.alert({
          message: infoText,
          callback: function() {
            $("#panel_1 .btn-next-panel").trigger("click");
          }
        });
      } else {
        $("#panel_1 .btn-next-panel").trigger("click");
      }
    };

    // AT-1394: de vorm van de postcode hangt af van het land; dezelfde regels als
    // PostcodeArea::INPUT_FORMATS. Andere landen: vrij, daar bewaren we alleen het land.
    //
    // De patronen staan hier één keer. ng-pattern bewaakt de uitkomst van
    // postcodePattern() in elke digest; een nieuwe RegExp per aanroep telt als een
    // gewijzigde waarde, en dan draait Angular door tot infdig en valt de hele shop stil.
    var POSTCODE_PATTERNS = {
      '172': /^\s*\d{4}\s*([a-zA-Z]{2})?\s*$/,
      '21': /^\s*\d{4}\s*$/,
      '59': /^\s*\d{5}\s*$/
    };
    var ANY_POSTCODE = /^.*$/;
    $scope.postcodePattern = function() {
      var attrs = $scope.formData && $scope.formData.order && $scope.formData.order.customer_attributes;
      var country = attrs ? String(attrs.postcode_country || '172') : '172';
      return POSTCODE_PATTERNS[country] || ANY_POSTCODE;
    };

    var hasInvalidCustomerFields = function() {
      if (!$scope.form) return false;

      var hasInvalid =
        (angular.isDefined($scope.form.firstname) && $scope.form.firstname.$invalid) ||
        (angular.isDefined($scope.form.lastname) && $scope.form.lastname.$invalid) ||
        (angular.isDefined($scope.form.email) && $scope.form.email.$invalid);

      if (angular.isDefined($scope.form.gender)) {
        hasInvalid = hasInvalid || $scope.form.gender.$invalid;
      }
      // AT-1394: de postcodevraag; leeg mag (tenzij verplicht, AT-1414), een verkeerde vorm niet.
      if (angular.isDefined($scope.form.postcode_area)) {
        hasInvalid = hasInvalid || $scope.form.postcode_area.$invalid;
      }
      // AT-1414: gender en leeftijd, als het evenement ze verplicht stelt.
      if (angular.isDefined($scope.form.salutation_id)) {
        hasInvalid = hasInvalid || $scope.form.salutation_id.$invalid;
      }
      if (angular.isDefined($scope.form.age_group_id)) {
        hasInvalid = hasInvalid || $scope.form.age_group_id.$invalid;
      }
      if (angular.isDefined($scope.form.phone)) {
        hasInvalid = hasInvalid || $scope.form.phone.$invalid;
      }
      if (angular.isDefined($scope.form.memo1)) {
        hasInvalid = hasInvalid || $scope.form.memo1.$invalid;
      }
      if (angular.isDefined($scope.form.memo2)) {
        hasInvalid = hasInvalid || $scope.form.memo2.$invalid;
      }
      if (angular.isDefined($scope.form.memo3)) {
        hasInvalid = hasInvalid || $scope.form.memo3.$invalid;
      }
      if (angular.isDefined($scope.form.relation_number)) {
        hasInvalid = hasInvalid || $scope.form.relation_number.$invalid;
      }

      if (angular.isDefined($scope.form.street)) {
        hasInvalid = hasInvalid || $scope.form.street.$invalid;
      }
      if (angular.isDefined($scope.form.housenumber)) {
        hasInvalid = hasInvalid || $scope.form.housenumber.$invalid;
      }
      if (angular.isDefined($scope.form.city)) {
        hasInvalid = hasInvalid || $scope.form.city.$invalid;
      }
      if (angular.isDefined($scope.form.zipcode) || angular.isDefined($scope.form.zipcode_nl)) {
        hasInvalid = hasInvalid ||
          (angular.isDefined($scope.form.zipcode) && $scope.form.zipcode.$invalid) ||
          (angular.isDefined($scope.form.zipcode_nl) && $scope.form.zipcode_nl.$invalid);
      }

      return hasInvalid;
    };

    $scope.$watch(hasInvalidCustomerFields, function(hasInvalid) {
      if ($scope.customerSubmitted && !hasInvalid) {
        $scope.customerSubmitted = false;
      }
    });

    $scope.customerInfoInvalidClass = function() {
      if ($scope.customerSubmitted && hasInvalidCustomerFields()) {
        return 'text-danger';
      }
      return '';
    };

    $scope.selectGender = function(value) {
      $scope.formData.order.customer_attributes.salutation_id = value;
      $timeout(function() {
        if ($scope.form && $scope.form.gender) {
          $scope.form.gender.$setDirty();
          $scope.form.gender.$validate();
        }
      }, 0);
    };

    var hasInvalidPaymentFields = function() {
      if (!$scope.form) return false;

      var hasInvalid = false;

      if (angular.isDefined($scope.form.payment)) {
        hasInvalid = hasInvalid || $scope.form.payment.$invalid;
      }

      if (angular.isDefined($scope.form['ideal[issuer_id]'])) {
        hasInvalid = hasInvalid || $scope.form['ideal[issuer_id]'].$invalid;
      }

      if (angular.isDefined($scope.form.shipping)) {
        hasInvalid = hasInvalid || $scope.form.shipping.$invalid;
      }

      if (angular.isDefined($scope.form.terms)) {
        hasInvalid = hasInvalid || $scope.form.terms.$invalid;
      }

      return hasInvalid;
    };

    $scope.$watch(hasInvalidPaymentFields, function(hasInvalid) {
      if ($scope.submitted && !hasInvalid) {
        $scope.submitted = false;
      }
    });

    $scope.paymentMethodInvalidClass = function() {
      if ($scope.submitted && hasInvalidPaymentFields()) {
        return 'text-danger';
      }
      return '';
    };

    $scope.adjustCarouselAndStock = function() {
      var show_message = true;
      var free_capacity_for_all_products;

      free_capacity_for_all_products = $scope.performance.free_capacity;

      angular.forEach($scope.event_data.categories, function(category) {
        if (category.startdate) {
          var check = dateCheck(category.startdate, category.enddate, $scope.performance.start);
          category.hide = !check;
        }
      });

      angular.forEach($scope.event_data.categories, function(category) {
        angular.forEach(category.products, function(product) {

          var selected_date = $filter('date')($scope.performance.start, 'yyyy-MM-dd');
          var selected_time = $filter('date')($scope.performance.start, 'HH:mm');

          // AT-1233: verkoopperiode in bezoekdagen. Leeg aan een kant betekent geen grens
          // aan die kant, allebei leeg betekent te koop op alle dagen. De oude orange-shop
          // filtert dit server-side, orange2 rendert client-side en moet het hier doen.
          product.outside_sale_window =
            (product.sale_from_date && selected_date < product.sale_from_date) ||
            (product.sale_till_date && selected_date > product.sale_till_date) || false;
          if (product.outside_sale_window && product.amount) {
            product.amount = 0;
          }
          var a = selected_time.split(':');
          var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60;
          var product_price_variant = null;
          var matching_product_price_variant = null;
          var stored = null;

          for (var i = product.product_price_variants.length - 1; i >= 0; i--) {
            product_price_variant = product.product_price_variants[i];

            if (product_price_variant.from_time_in_seconds !== null) {
              product_price_variant.timecheck = ((seconds >= product_price_variant.from_time_in_seconds) &&
                  (seconds < product_price_variant.till_time_in_seconds));
            } else {
              product_price_variant.timecheck = false;
            }

            if (product_price_variant.from_date !== null) {
              product_price_variant.datecheck = dateCheck(product_price_variant.from_date, product_price_variant.till_date, selected_date);
            } else {
              product_price_variant.datecheck = false;
            }
            product_price_variant.dayCheck = product_price_variant.weekdays[new Date($scope.performance.start).getDay()];
          }

          for (i = product.product_price_variants.length - 1; i >= 0; i--) {
            product_price_variant = product.product_price_variants[i];

            if ((product_price_variant.datecheck) && (product_price_variant.timecheck) && (product_price_variant.dayCheck)) {
              matching_product_price_variant = product_price_variant;
              break;
            }
          }

          if (matching_product_price_variant === null) {
            for (i = product.product_price_variants.length - 1; i >= 0; i--) {
              product_price_variant = product.product_price_variants[i];

              if ((product_price_variant.from_time_in_seconds === null) &&
                  (product_price_variant.datecheck === true) && (product_price_variant.dayCheck)) {
                matching_product_price_variant = product_price_variant;
                break;
              }
            }
          }

          if (matching_product_price_variant === null) {
            for (i = product.product_price_variants.length - 1; i >= 0; i--) {
              product_price_variant = product.product_price_variants[i];

              if ((product_price_variant.from_date === null) &&
                  (product_price_variant.timecheck === true) && (product_price_variant.dayCheck)) {
                matching_product_price_variant = product_price_variant;
                break;
              }
            }
          }

          if (matching_product_price_variant !== null) {
            if (product.original_values === undefined) {
              product.original_values = {};
              product.original_values.price = product.price;
              product.original_values.name_nl = product.name_nl;
              product.original_values.name_en = product.name_en;
              product.original_values.name_fr = product.name_fr;
              product.original_values.name_de = product.name_de;
            }

            product.price = matching_product_price_variant.price;
            if (matching_product_price_variant.name_nl)
              product.name_nl = matching_product_price_variant.name_nl;
            if (matching_product_price_variant.name_en)
              product.name_en = matching_product_price_variant.name_en;
            if (matching_product_price_variant.name_fr)
              product.name_fr = matching_product_price_variant.name_fr;
            if (matching_product_price_variant.name_de)
              product.name_de = matching_product_price_variant.name_de;

            product.matching_product_price_variant = true;
          } else {
            if ('original_values' in product) {
              product.price = product.original_values.price;
              product.name_nl = product.original_values.name_nl;
              product.name_en = product.original_values.name_en;
              product.name_fr = product.original_values.name_fr;
              product.name_de = product.original_values.name_de;
              product.matching_product_price_variant = false;
            }
          }

          if (product.product_price_variants.length > 0) {
            calculate_total_and_handling_cost();
          }

          if (product.performance_stock_enabled === true) {
            var available_stock = getAvailableStock(product, $scope.performance);

            product.sold_out = (available_stock === 0) ? {"text-decoration": "line-through"} : null;

            if (Number(product.max_range) > available_stock) {
              if (product.amount > available_stock) {
                product.amount = available_stock;
              }
              product.free_capacity = available_stock;
            } else {
              product.free_capacity = undefined;
            }
          }
        });
      });
      $scope._stockClampWarned = false;
      recomputeAllProductMaxChoices($scope);
    };

    $scope.$watch("formData.order.donation_item_attributes.price", function() {
      calculate_total_and_handling_cost();
    });

    var lastTrackedPaymentMethod = null;
    $scope.$watch("formData.order.payment_method", function(newValue, oldValue) {
      calculate_total_and_handling_cost();

      if (newValue && newValue !== lastTrackedPaymentMethod && $scope.products) {
        lastTrackedPaymentMethod = newValue;
        var paymentItems = buildGA4Items($scope.products, $scope.formData.order.event_id);
        if (paymentItems.length > 0) {
          trackGA4Event('add_payment_info', {
            currency: 'EUR',
            value: parseFloat(($scope.orderTotal || 0).toFixed(2)),
            payment_type: String(newValue),
            items: paymentItems
          });

          trackTikTokEvent('AddPaymentInfo', {
            currency: 'EUR',
            value: parseFloat(($scope.orderTotal || 0).toFixed(2)),
            contents: buildTikTokContents($scope.products)
          });
        }
      }
    });

    $scope.$watch("formData.order.shipping_method_id", function() {
      calculate_total_and_handling_cost();
    });

    $scope.redeemPromoCode = function() {
      $scope.promo_message = "";

      build_order_items_on_form_data();

      if (!$scope.formData.order.order_items_attributes.length) {
        $scope.promo_class = "alert-danger";
        $scope.promo_message = I18n.t("js.first_select_your_products");
        $scope.promo_code = "";
        return false;
      }

      if (!$scope.promo_code.length) {
        $scope.promo_class = "alert-danger";
        $scope.promo_message = I18n.t("js.first_enter_a_promo_code");
        return false;
      }

      if (_.include($scope.promo_codes, $scope.promo_code)) {
        $scope.promo_class = "alert-danger";
        $scope.promo_message = "Oeps, deze kortingscode is al gebruikt.";
        $scope.promo_code = "";
        return false;
      }

      var ajax_params = {};
      ajax_params.method = "POST";
      ajax_params.url = "/transactions/redeem_promo_code";
      ajax_params.data = {
        transaction: {
          order: $scope.formData.order,
          code: $scope.promo_code
        }
      };
      if ($scope.promo_codes.length > 0) {
        ajax_params.data.transaction.codes = $scope.promo_codes;
      }
      var responsePromise = $http(ajax_params);
      responsePromise.success(function(data, status, headers, config) {
        if (data.result.type == "notice") {
          $scope.discount = 0;
          $scope.promo_class = "alert-success";
          $scope.promo_message = data.result.message;
          $scope.promo_codes.push(data.code);
          $scope.number_of_free_tickets = data.free_tickets;
          angular.forEach(data.order.order_items, function(backend_order_item) {
            $scope.discount += parseFloat(backend_order_item.discount) || 0;
          });
          if (data.order.discount_item) {
            $scope.discount += parseFloat(data.order.discount_item.discount);
          }
          jQuery("#discount_line").css("background", "#dff0d8");
          setTimeout(function() {
            jQuery("#discount_line").css("background", "transparent");
          }, 2000);
          calculate_total_and_handling_cost();
        }
        if (data.result.type == "error") {
          $scope.promo_class = "alert-danger";
          $scope.promo_message = data.result.message;
        }
      });
      responsePromise.error(function(data, status, headers, config) {
        $scope.promo_class = "alert-danger";
        $scope.promo_message = I18n.t("js.technical_problems");
        $scope.promo_code = "";
      });
      $scope.promo_code = "";
    };

    $scope.processForm = function() {

      // AT-1237: bij tickets voor meerdere dagen draagt elke regel zijn eigen tijdslot, dus
      // er is geen bezoekdatum voor de bestelling als geheel en die kan hier niet ontbreken.
      if ($scope.event_data.performances.length && !$scope.event_data.allow_multi_day_orders &&
          (!$scope.formData.order.performance_id)) {
        bootbox.alert(I18n.t("js.kies_uw_datum"));
        $scope.submitted = false;
        return;
      }

      if ($scope.form.$valid) {
        $scope.buttonDisabled = true;
        $scope.formValidAndSubmitted = true;
        build_order_items_on_form_data();
        var ajax_params = {};
        if ($scope.order_id === "") {
          ajax_params.method = "POST";
          ajax_params.url = "/transactions";
        } else {
          $scope.formData.order.id = $scope.order_id;
          ajax_params.method = "PUT";
          ajax_params.url = "/transactions/" + $scope.order_id;
        }

        ajax_params.data = {
          session_id: $("#sessionId").val(),
          promo: $scope.promo_uuid,
          transaction: {
            order: $scope.formData.order,
            relation_number: $scope.relationNumber
          }
        };
        if (typeof (Storage) !== "undefined") {
          try {
            ajax_params.data.iframe = sessionStorage.getItem('avayoReturnUrl');
          } catch (e) {
            // Full, Access denied :-(
          }
        }
        if ($scope.promo_codes.length > 0) {
          ajax_params.data.transaction.codes = $scope.promo_codes;
        }

        if ($scope.order_id === "") {
          ajax_params.data.transaction.order.utm_source   = $location.search().utm_source;
          ajax_params.data.transaction.order.utm_medium   = $location.search().utm_medium;
          ajax_params.data.transaction.order.utm_campaign = $location.search().utm_campaign;
          ajax_params.data.transaction.order.utm_content  = $location.search().utm_content;
          ajax_params.data.transaction.order.utm_term     = $location.search().utm_term;
        }

        // set phone number + country code
        if ($("#phone").length === 1) {
          ajax_params.data.transaction.order.customer_attributes.phone = $("#phone").intlTelInput("getNumber");
        }

        $http(ajax_params)
            .success(function(data) {
              if (!data.success) {
                $scope.buttonDisabled = false;
                $scope.formValidAndSubmitted = false;
                $scope.submitted = false;

                bootbox.alert({
                  title: "Oeps...",
                  message: data.errors,
                  callback: function() {
                    if (data.reload) {
                      location.reload();
                    }
                  }
                });

              } else {
                $scope.order_id = data.order_id;

                // GA4: begin_checkout event with items
                var checkoutItems = buildGA4Items($scope.products, $scope.formData.order.event_id);
                trackGA4Event('begin_checkout', {
                  currency: 'EUR',
                  value: parseFloat(parseFloat($scope.orderTotal || 0).toFixed(2)),
                  items: checkoutItems
                });

                trackTikTokEvent('InitiateCheckout', {
                  currency: 'EUR',
                  value: parseFloat(parseFloat($scope.orderTotal || 0).toFixed(2)),
                  contents: buildTikTokContents($scope.products)
                });

                var metaCheckoutPayload = buildMetaPayload($scope.products);
                var metaNumItems = metaCheckoutPayload.contents.reduce(function(sum, c) { return sum + c.quantity; }, 0);
                trackMetaEvent('InitiateCheckout', {
                  content_type: 'product',
                  content_ids: metaCheckoutPayload.content_ids,
                  contents: metaCheckoutPayload.contents,
                  currency: 'EUR',
                  value: parseFloat(parseFloat($scope.orderTotal || 0).toFixed(2)),
                  num_items: metaNumItems
                });

                if (data.top_window === true) {
                  window.top.location = data.next_page;
                } else {
                  window.location = data.next_page;
                }
              }
            })
            // AT-1434: serverfout, timeout of geen verbinding. Zonder deze handler
            // bleef de knop uitgeschakeld en zag de bezoeker niets.
            .error(function() {
              $scope.buttonDisabled = false;
              $scope.formValidAndSubmitted = false;
              $scope.submitted = false;

              bootbox.alert({
                title: "Oeps...",
                message: I18n.t("js.technical_problems")
              });
            });
      } else {
        if ((($scope.country == 1)) && ($scope.zipcode_nl) && ($scope.zipcode_nl.length > 5)) {
          $scope.zipcodeDutchLookup();
        }
      }
    };

    $scope.setTestData = function() {
      var u = "test" + Math.random().toString(36).substring(2, 7);
      $scope.formData.order.customer_attributes.salutation_id = 1;
      $scope.formData.order.customer_attributes.phone = "0321654987";
      $scope.formData.order.customer_attributes.firstname = "voornaam";
      $scope.formData.order.customer_attributes.lastname = "achternaam";
      $scope.formData.order.customer_attributes.email = u + "@gmail.com";
      $scope.formData.order.customer_attributes.email_confirm = u + "@gmail.com";
      $scope.formData.order.customer_attributes.organisation = u;
      $scope.terms = true;
      $scope.$apply();
    };


    //
    // private
    //

    var build_order_items = function(data) {
      var order_item = _.findWhere($scope.order_items, {id: data.product_id});

      if (angular.isUndefined(order_item)) {
        var product = _.findWhere($scope.products, {id: data.product_id});
        $scope.order_items.push({
          id: data.product_id,
          product: product,
          amount: data.product_amount,
          order_item_id: data.order_item_id
        });
      } else {
        order_item.amount = data.product_amount;
      }
    };

    var calculate_total_and_handling_cost = function() {
      $scope.handlingCost = parseFloat($('input[name=payment]:checked').data('additional-costs')) || 0;
      $scope.handlingCost += parseFloat($('input[name=shipping]:checked').data('additional-costs')) || 0;
      $scope.orderTotal = 0;
      $scope.orderSubtotal = 0;
      $scope.nrTickets = 0;
      var order_item_amount;
      var amounts = 0;
      var tickets_without_handling_cost = 0;

      angular.forEach($scope.order_items, function(element) {
        $scope.orderSubtotal += element.amount * element.product.price;
        $scope.nrTickets += element.amount;
        if (element.product.price > 0) {
          if (element.product.nr_physical_tickets === 0)
            order_item_amount = element.amount;
          else
            order_item_amount = element.amount * element.product.nr_physical_tickets;
          amounts += order_item_amount;
          if (element.product.no_handling_cost_customer === true) {
            tickets_without_handling_cost += order_item_amount;
          }
        }
      });

      $scope.orderTotal = $scope.orderSubtotal;

      var number_of_paid_tickets = amounts - tickets_without_handling_cost - $scope.number_of_free_tickets;
      if (number_of_paid_tickets < 0)
        number_of_paid_tickets = 0;
      $scope.handlingCost += number_of_paid_tickets * $scope.event_data.handling_cost_per_ticket;
      if (number_of_paid_tickets > 0) {
        $scope.handlingCost += $scope.event_data.handling_cost;
      }

      if ($scope.nrTickets === 0) {
        $scope.nrTickets = null;
      }

      if (($scope.event_data.max_handling_cost > 0) && ($scope.handlingCost > $scope.event_data.max_handling_cost)) {
        $scope.handlingCost = $scope.event_data.max_handling_cost;
      }

      if (amounts === 0) {
        $scope.orderTotal = 0;
        $scope.orderSubtotal = 0;
        $scope.handlingCost = 0;
        $scope.discount = 0;
      }

      let fees = [];

      $scope.fee_definitions.forEach(fd => {
        if (!fd.mandatory) return;

        let qty = 0;
        switch (fd.fee_type) {
          case 'per_order':   qty = 1; break;
          case 'per_ticket':  qty = $scope.nrTickets; break;
          case 'per_visitor': qty = $scope.nrTickets; break;
          default: qty = 0;
        }

        if (qty <= 0) return;

        const amount = parseFloat(fd.amount || 0);
        const subtotalFee = qty * amount;

        fees.push({
          id: fd.id,
          name: fd.name,
          description: (fd.description || '')
            .replace('%{count}', qty)
            .replace('%{amount}', amount.toFixed(2)),
          fee_type: fd.fee_type,
          quantity: qty,
          amount: amount,
          subtotal: subtotalFee,
          currency: fd.currency || 'EUR'
        });
      });

      const feesTotal = fees.reduce((sum, f) => sum + f.subtotal, 0);

      $scope.fees = fees;
      $scope.fees_total = feesTotal;
      $scope.orderTotal += feesTotal;

      if ($scope.event_data.buyer_is_paying_handling_cost) {
        $scope.handlingCost = ServiceCost.calc($scope.event_data.psp,
            $scope.orderTotal, number_of_paid_tickets, $scope.formData.order.payment_method);
      }

      $scope.orderTotal -= $scope.discount;

      if ($scope.orderTotal <= 0) {
        $scope.orderTotal = 0;
        $scope.handlingCost = 0;
      } else {
        $scope.orderTotal += $scope.handlingCost;
        if ($scope.orderTotal < 0) {
          $scope.orderTotal = 0;
        }
      }

      // donation
      if (
          $scope.formData.order.donation_item_attributes &&
          $scope.formData.order.donation_item_attributes.price &&
          $scope.formData.order.donation_item_attributes.price > 0
      ) {
        $scope.orderTotal += $scope.formData.order.donation_item_attributes.price;
      }

    };

    // Orange2 specific: increment/decrement product functions
    $scope.incrementProduct = function(product) {
      if (!product) return;
      var currentAmount = product.amount || 0;
      // When incrementing from 0, jump to min_range to respect ticket range
      var newAmount = (currentAmount === 0 && product.min_range > 1) ? product.min_range : currentAmount + 1;
      var maxAmount = product.max_range;
      if (product.free_capacity && product.free_capacity < maxAmount) {
        maxAmount = product.free_capacity;
      }
      if (newAmount <= maxAmount) {
        product.amount = newAmount;
        $scope.update({
          product_id: product.id,
          product_amount: newAmount
        });
        hideProductsError();

        trackGA4Event('add_to_cart', {
          currency: 'EUR',
          value: parseFloat(parseFloat(product.price || 0).toFixed(2)),
          items: [buildGA4Item(product, $scope.formData.order.event_id, 1)]
        });

        trackTikTokEvent('AddToCart', {
          currency: 'EUR',
          value: parseFloat(parseFloat(product.price || 0).toFixed(2)),
          contents: [buildTikTokContent(product, 1)]
        });

        trackMetaEvent('AddToCart', {
          content_type: 'product',
          content_ids: [String(product.id)],
          contents: [{ id: String(product.id), quantity: 1 }],
          currency: 'EUR',
          value: parseFloat(parseFloat(product.price || 0).toFixed(2))
        });
      }
    };

    $scope.decrementProduct = function(product) {
      if (!product) return;
      var newAmount = (product.amount || 0) - 1;
      // When decrementing below min_range, jump to 0 (or stay at min_range for mandatory)
      if (newAmount > 0 && newAmount < (product.min_range || 1)) {
        newAmount = product.mandatory ? (product.min_range || 1) : 0;
      }
      if (product.mandatory && newAmount < (product.min_range || 1)) return;
      if (newAmount >= 0) {
        product.amount = newAmount;
        $scope.update({
          product_id: product.id,
          product_amount: newAmount
        });
        hideProductsError();

        trackGA4Event('remove_from_cart', {
          currency: 'EUR',
          value: parseFloat(parseFloat(product.price || 0).toFixed(2)),
          items: [buildGA4Item(product, $scope.formData.order.event_id, 1)]
        });
      }
    };

    // AT-1436: bij één zichtbare groep staat die open en is de kop verborgen, bij meer
    // groepen staan ze allemaal ingeklapt zodat de bezoeker eerst het soort kiest.
    // Groepen buiten hun periode (category.hide) tellen niet mee.
    $scope.visibleCategoryCount = function() {
      var count = 0;
      angular.forEach($scope.event_data && $scope.event_data.categories, function(category) {
        if (!category.hide) count++;
      });
      return count;
    };

    $scope.getCategoryProductCount = function(category) {
      if (!category || !category.products) return 0;
      var count = 0;
      angular.forEach(category.products, function(product) {
        if (!product.sold_out && !product.manual_sold_out) {
          count++;
        }
      });
      return count;
    };

    $scope.getCategorySelectedCount = function(category) {
      if (!category || !category.products) return 0;
      var total = 0;
      angular.forEach(category.products, function(product) {
        if (product.amount > 0) {
          total += product.amount;
        }
      });
      return total;
    };

    $scope.getCategoryTotal = function(category) {
      if (!category || !category.products) return 0;
      var total = 0;
      angular.forEach(category.products, function(product) {
        if (product.amount > 0) {
          total += (product.amount * product.price);
        }
      });
      return total;
    };

    $scope.$watch('handlingCost', function(newVal) {
      var totalTickets = 0;
      angular.forEach($scope.order_items, function(item) {
        if (item.amount > 0) {
          totalTickets += item.amount;
        }
      });
      $scope.handlingCostPerTicket = totalTickets > 0 ? (newVal / totalTickets) : 0;
    });

    var validateProductsPanel = function() {
      var hasTickets = false;
      angular.forEach($scope.order_items, function(item) {
        if (item.amount > 0) {
          hasTickets = true;
        }
      });

      if (!hasTickets) {
        $scope.productsSubmitted = true;
        $scope.productsFadingOut = false;
        $scope.$apply();

        setTimeout(function() {
          $scope.productsFadingOut = true;
          $scope.$apply();
        }, 3500);

        setTimeout(function() {
          $scope.productsSubmitted = false;
          $scope.productsFadingOut = false;
          $scope.$apply();
        }, 4000);
      }

      return hasTickets;
    };

    var validateDatepickerPanel = function() {
      var isValid = $scope.formData.order.performance_id && $scope.formData.order.performance_id > 0;

      if (!isValid) {
        $scope.datepickerSubmitted = true;
        $scope.datepickerFadingOut = false;
        $scope.$apply();

        setTimeout(function() {
          $scope.datepickerFadingOut = true;
          $scope.$apply();
        }, 3500);

        setTimeout(function() {
          $scope.datepickerSubmitted = false;
          $scope.datepickerFadingOut = false;
          $scope.$apply();
        }, 4000);
      }

      return isValid;
    };

    var validateCustomerPanel = function() {
      return !hasInvalidCustomerFields();
    };

    window.validatePanelOnLeave = function(panelId) {
      var $panel = $('#' + panelId);
      var isValid = false;

      if (panelId === 'panel_datepicker') {
        isValid = validateDatepickerPanel();
      } else if (panelId === 'panel_products') {
        isValid = validateProductsPanel();
      } else if (panelId === 'panel_customer_information') {
        isValid = validateCustomerPanel();
        if (!isValid) {
          $scope.customerSubmitted = true;
          $scope.$apply();
        }
      } else if (panelId === 'panel_overview' || panelId === 'panel_donation') {
        isValid = true;
      } else {
        return true;
      }

      if (isValid) {
        $panel.addClass('completed').removeClass('has-error');
      } else {
        $panel.addClass('has-error').removeClass('completed');
      }

      return isValid;
    };

    var build_order_items_on_form_data = function() {
      $scope.formData.order.order_items_attributes = [];
      angular.forEach($scope.order_items, function(order_item, key) {
        var io = {amount: order_item.amount, product_id: order_item.id};
        if (!angular.isUndefined(order_item.order_item_id)) {
          io.id = order_item.order_item_id;
        }
        $scope.formData.order.order_items_attributes.push(io);
      });
    };

  }]);

  myApp.config(['$locationProvider', function($locationProvider) {
    $locationProvider.html5Mode(true);
  }]);

  /* Directives */
  angular.module("myApp.directives", [])
      .directive("emailCheck", [function() {
        return {
          require: "ngModel",
          link: function(scope, elem, attrs, ctrl) {
            var firstEmail = "#" + attrs.emailCheck;
            elem.on("blur keyup", function() {
              scope.$apply(function() {
                ctrl.$setValidity("emailmatch", elem.val() === $(firstEmail).val());
              });
            });
          }
        };
      }]);

}());
